import script from "./BaseMultiPageImage.vue?vue&type=script&lang=js"
export * from "./BaseMultiPageImage.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__